/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-01-17T17:13:41-08:00
* @Email:  daniel@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-08-11T11:57:45-07:00
*/



import React, { Component } from 'react';
import Header from '../../blocks/Header';
import Headline from '../../common/Headline';
import { Link } from 'react-router';
import TextLink from '../../common/TextLink';
import Container from '../../blocks/Container';
import Modal from '../../common/Modal';
import { tsDate } from '../../../common'
import Text from '../../common/Text'

class ManageSubscription extends Component {


  constructor(props) {
    super(props);
    this.renderSubscriptionText = this.renderSubscriptionText.bind(this);
  }

  renderSubscriptionText() {
    let { subscription } = this.props;

    if(subscription) {

      let thePackage = subscription.package.data;

      if(subscription.status === "active") {
        // show active subscription
        return (<span>
          <h4>{thePackage.description}</h4>
          <Text>Your subscription will renew on {tsDate(subscription.expire_at.date)}</Text>
          <Modal linkText={<TextLink>Cancel Subscription</TextLink>}
            yesCallback={this.props.confirmCancel}>Are you sure you want to cancel your subscription?</Modal>
          </span>
        );
      } else {
        // show canceled subscription details.
        return (<span><h4>{thePackage.description}</h4>Your subscription was canceled.</span>);
      }

    } else {
      // no subscription;
      // TODO: we need to
      return (<span>You have no recurring subscription</span>);
    }
  }

  render() {
    //console.log("my subscription:");
    //console.log(this.props.subscription);



    return (
      <div>
        <Header>
          <Headline>Your Subscription</Headline>
        </Header>
        <Container spacedBottom>
          <TextLink to="/billing/history">Billing History</TextLink> {this.renderSubscriptionText()}
        </Container>
    </div>

    );
  }
}

export default ManageSubscription;



// WEBPACK FOOTER //
// ./src/components/pages/Settings/ManageSubscription.jsx